const TimeSheet = {
  timequerydata: []
};

export default function(state = TimeSheet, action) {
  switch (action.type) {
    case "RealTimeUpdate for TimeSheet":
      let newtimedata = action.payload;
      return {
        ...state,
        timequerydata: newtimedata
      };
      break;

    default: {
      return {
        state
      };
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/time-reducer.js